import { render } from "./Akira.vue?vue&type=template&id=774e1a9e&scoped=true"
const script = {}

import "./Akira.vue?vue&type=style&index=0&id=774e1a9e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774e1a9e"]])

export default __exports__